<template>
  <div>
    <van-empty :description="$t('pickupcard.no_student')" v-if="emptyChild" />
    <van-skeleton title :row="23" :loading="loading" v-else>
      <van-notice-bar
        ref='notice'
        v-if="dataList.audit_status==2"
        wrapable
        left-icon="volume-o"
        :scrollable="false"
        :text="dataList.audit_comments"
      />
      <van-notice-bar
        ref='notice'
        v-if="dataList.audit_status==1"
        wrapable
        left-icon="volume-o"
        :scrollable="false"
        :text="$t('homeAddress.info_complete')"
      />
      <div class="mb-10 word relative" ref='bgImg'>
        <div class="bgImg" >
          <van-row type="flex" justify="end">
            <switch-lang color='#377ED7' />
          </van-row>
          <div class="mb-10 mt-10" v-html="tipsText"></div> 
        </div>
      </div>
      <div class="background" >
        <div class="mt-15">
            <children @change="childChange" :children="childrenList" v-if="childrenList.length>0" />
        </div>
        <div class="container" style="margin-bottom: 70px;">
          <div class="font16 color3 mb-20"> {{$t('router.bankInfo')}}</div>
          <div class="mt-20">
            <div class="label"> {{$t('bankInfo.name')}}</div>
            <van-field
             class='bgGray'
              v-model="bank_user"
              :placeholder="$t('global.please_input')"
            />
          </div>
           <div class="mt-15">
            <div class="label"> {{$t('bankInfo.bankName')}}</div>
            <van-field
             class='bgGray'
              v-model="bank_name"
              :placeholder="$t('global.please_input')"
            />
          </div>
           <div class="mt-15">
            <div class="label"> {{$t('bankInfo.bankAddress')}}</div>
            <van-field
             class='bgGray'
              v-model="bank_city"
              :placeholder="$t('global.please_input')"
            />
          </div>
           <div class="mt-15">
            <div class="label"> {{$t('bankInfo.number')}}</div>
            <van-field
             class='bgGray'
             type="digit"
              v-model="bank_account"
              :placeholder="$t('global.please_input')"
            />
          </div>
          <div class="btnBox">
            <van-button type="info" block class="saveSub" disabled v-if="!dataList.state">{{$t('pickupcard.not_edit')}}</van-button>
             <van-button type="info" block class="saveSub" v-else-if='dataList.audit_status==1' disabled >{{$t('global.ok')}}</van-button>
            <van-button type="info" block class="saveSub" v-else @click='saveInfo()' :disabled='saveCurrent' >{{$t('global.ok')}}</van-button>
          </div>
        </div>
      </div>
       <van-dialog
        v-model="isShow"
        show-cancel-button
        :beforeClose="beforeClose"
      >
        <div class="p15">
          <van-row type="flex" justify="center">
            <div class="mb-10"><strong>{{$t('pickupcard.apply_to')}}</strong></div>
          </van-row>
          <van-checkbox-group v-model="childIds"  class="mb-10">
            <van-checkbox v-for="(list,i) in childrenList" :key='i' class="mt-15" :name='list.id' :disabled="!childrenStatus[list.id]"> {{list.name}}</van-checkbox>
          </van-checkbox-group>
        </div>
      </van-dialog>
    </van-skeleton>
  </div>
</template>

<script>
import Vue from 'vue';
import { Form, Icon, Toast, Button, Row, Skeleton, Field, Dialog} from 'vant';
import Children from '@/components/Children'
import storage from 'store'
import { CURRENT_CHILD } from '@/store/mutation-types'
import { childList } from '@/api/child'
import SwitchLang from '@/components/SwitchLang'
import {infoShow, infoSave, infoStatus } from '@/api/BankInfo'

Vue.use(Form);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Row);
Vue.use(Skeleton);
Vue.use(Field);
export default {
  name: 'Pickup',
   components: {
    'children': Children,
    'switch-lang':SwitchLang
  },
  data() {
    return {
      loading: false,
      tipsText:'',
      childrenList:[],
      childrenStatus: {},
      bank_user:'',
      bank_name:'',
      bank_account:'',
      bank_city:'',
      childIds:[],
      isShow:false,
      saveCurrent:false,
      emptyChild: false,
      dataList:{}
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background-color:#fff;')
  },
  created () {
    childList().then(res => {
      this.childrenList=res.data
      this.loading = false
      let cIds = [];
      this.childrenList.map(item => {
        this.childrenStatus[item.id] = true
        cIds.push(item.id)
      })
      if (this.childrenList.length < 1) {
        this.emptyChild = true
      }
      let cid = storage.get(CURRENT_CHILD) ? storage.get(CURRENT_CHILD).id : ''
      this.childid = cIds.indexOf(cid) > -1 ? cid : cIds[0]
    })
  },
  methods: {
    childChange(val) {
      this.childid = val.id
      this.getBank()
    },
    getBank(){
      infoShow({childId:this.childid}).then(res => {
         this.dataList=res.data
         this.tipsText=res.data.tipsText
         this.bank_name=res.data.bank_name
         this.bank_user=res.data.bank_user
         this.bank_city=res.data.bank_city
         this.bank_account=res.data.bank_account
        })
    },
    saveInfo(){
      if (this.childrenList.length > 1) {
        this.childIds=[]
        this.childIds.push(this.childid)
        infoStatus().then(res => {
          this.isShow = !this.isShow
          this.childrenStatus = res.data
        })
        }else{
          this.save()
        }
    },
    save(done){
      this.saveCurrent=true
      var childid=[]
      if (this.childrenList.length > 1) {
        childid=this.childIds
      }else{
        childid.push(this.childid)
      }
      if(childid.length==0){
        Toast(this.$t('homeAddress.select_child'))
        done(false)
        this.saveCurrent=false
        return
      }
      infoSave({
        childId: childid,
        address: this.address,
        bank_name:this.bank_name,
        bank_user:this.bank_user,
        bank_city:this.bank_city,
        bank_account:this.bank_account,
      }).then(response => {
        if (response.code == 0) {
          this.dataList.audit_status=0
          Toast(response.msg || '提交成功')
          if(done){
            done()
          }
          this.saveCurrent=false
        }else{
          done(false) 
          this.saveCurrent=false
        }
      })
    },
    beforeClose(action, done) {
      if(action === 'confirm') {
          this.save(done)
      } else if(action === 'cancel') {
         done() //关闭
      }
    },
  }
}
</script>

<style lang="less" scoped>
.relative{
  position: relative;
}
.word{
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 21px;
    background:#7EA9F6;
    .bgImg{
      background-image:url('../assets/bankInfo.png');
      padding:16px;
      background-repeat:no-repeat;
      background-position:bottom right;
      min-height:110px;
    }
}
.background{
  background:#fff;
}
.p15{
  padding:20px
}
.container{
  padding:25px 16px 0px;
  font-size:12px;
  .label{
    height: 20px;
    font-size: 14px;
    color: #646566;
    line-height: 20px;
    margin-bottom:6px
  }
  .bgGray{
    background: #F7F8FA;
  }
  
  .font16{
    font-size: 16px;
    font-weight:600;
  }
  .color3{
    color:#333
  }
  .btnBox{
    width: calc(100% - 32px);
    height: 55px;
    position: fixed;
    bottom:0px;
    // background: #fff;
    .saveSub{
      height: 40px;
      background: #4D88D2;
      border-radius: 100px;
    }
  }
  
}
</style>
